export const userchildren = [
  {
    path: '/userinfo/usermsg',
    name: 'usermsg',
    component: () => import('@/page/user/usermsg/usermsg'),
    meta: {
      title: '我的信息',
      role: 'grxx'
    }
  },
  {
    path: '/userinfo/password',
    name: 'editpassword',
    component: () => import('@/page/user/userpassword/editpassword'),
    meta: {
      title: '密码管理',
      role: 'mmxx'
    }
  },
  {
    path: '/userinfo/frequentselect',
    name: 'frequentselect',
    component: () => import('@/page/user/frequentselect/frequentselect'),
    meta: {
      title: '员工管理',
      role: 'ygxx'
    }
  },
  {
    path: '/userinfo/temporary',
    name: 'temporary',
    component: () => import('@/page/user/temporary/linke'),
    meta: {
      title: '临客管理',
      role: 'lkxx'
    }
  }
]
export const company = [
  {
    path: '/userinfo/company',
    name: 'cpmpanyinfo',
    component: () => import('@/page/user/company/cpmpanyinfo'),
    meta: {
      title: '公司信息',
      role: 'gsxx'
    }
  },
  {
    path: '/userinfo/companydeploy',
    name: 'companydeploy',
    component: () => import('@/page/user/companydeploy/companydeploy'),
    meta: {
      title: '公司配置',
      role: 'pzxx'
    }
  },
  {
    path: '/userinfo/roleManage',
    name: 'roleManage',
    component: () => import('@/page/user/roleManage/roleManage'),
    meta: {
      title: '角色管理',
      role: 'jsgl'
    }
  },
  {
    path: '/userinfo/section',
    name: 'companysection',
    component: () => import('@/page/user/section/section'),
    meta: {
      title: '部门信息',
      role: 'bmxx'
    }
  },
  {
    path: '/userinfo/project',
    name: 'project',
    component: () => import('@/page/user/project/project'),
    meta: {
      title: '成本中心项目管理',
      role: 'xmxx'
    }
  }]
export const travelSet = [
  {
    path: '/userinfo/travelrule',
    name: 'travelrule',
    component: () => import('@/page/user/travelrule/travelrule'),
    meta: {
      title: '差旅政策管理',
      role: 'clgzxx'
    }
  },
  {
    path: '/userinfo/rulest',
    name: 'rulest',
    component: () => import('@/page/user/rulest/rulest'),
    meta: {
      title: '审批规则管理',
      role: 'spgzxx'
    }
  },
  {
    path: '/userinfo/violationReason',
    name: 'violationReason',
    component: () => import('@/page/user/violationReason'),
    meta: {
      title: '超标原因管理',
      role: 'wgyy'
    }
  },
  {
    path: '/userinfo/tripProject',
    name: 'tripProject',
    component: () => import('@/page/user/tripProject'),
    meta: {
      title: '行程项目管理',
      role: 'xcmc'
    }
  }
]

export const bill = [
  {
    path: '/userinfo/bill',
    name: 'bill',
    component: () => import('@/page/user/bill/list'),
    meta: {
      title: '账单列表'
    }
  }
]
// 编辑页面
const secondPage = [
  {
    path: '/userinfo/frequentselect/exportPassengerPage',
    name: 'exportPassengerPage',
    component: () => import('@/page/user/frequentselect/exportPassengerPage'),
    meta: {
      title: '员工导入'
    }
  },
  {
    path: '/userinfo/frequentselect/jobGrade',
    name: 'jobGrade',
    component: () => import('@/page/user/frequentselect/jobGrade'),
    meta: {
      title: '职级维护'
    }
  },
  // 角色 添加、编辑
  {
    path: '/userinfo/roleManage/roleManageCU',
    name: 'roleManageCU',
    component: () => import('@/page/user/roleManage/roleManageCU')
  },
  // 员工 添加、编辑
  {
    path: '/userinfo/frequentselect/staffCU',
    name: 'staffCU',
    component: () => import('@/page/user/frequentselect/edit/edit-quent')
  },
  // 员工 修改账号
  {
    path: '/userinfo/frequentselect/accountU',
    name: 'accountU',
    component: () => import('@/page/user/frequentselect/personal/personal')
  },
  // 帮助手册
  {
    path: '/userinfo/help/manual',
    name: 'helpMmanual',
    component: () => import('@/page/user/helpMmanual')
  },
  // 临客 添加、编辑
  {
    path: '/userinfo/temporary/temporaryCU',
    name: 'temporaryCU',
    component: () => import('@/page/user/temporary/edit/edit')
  },
  // 项目 添加、编辑
  {
    path: '/userinfo/project/projectCU',
    name: 'projectCU',
    component: () => import('@/page/user/project/edit/project_edit')
  },
  // 差旅规则 添加、编辑
  {
    path: '/userinfo/travelrule/travelruleCU',
    name: 'travelruleCU',
    component: () => import('@/page/user/travelrule/edit/edit')
  },
  // 差旅规则关联 1部门 2项目 3员工
  {
    path: '/userinfo/travelrule/relateRule',
    name: 'relateRule',
    component: () => import('@/page/user/travelrule/edit/relateRule')
  },
  // 审批规则 添加、编辑
  {
    path: '/userinfo/rulest/rulestCU',
    name: 'rulestCU',
    component: () => import('@/page/user/rulest/edit/edit')
  },
  // 审批规则关联 1部门 2项目 3员工
  {
    path: '/userinfo/rulest/approveRelateRule',
    name: 'approveRelateRule',
    component: () => import('@/page/user/rulest/edit/approveRelateRule')
  },
  // 公司配置 编辑
  {
    path: '/userinfo/companydeploy/companydeployCU',
    name: 'companydeployCU',
    component: () => import('@/page/user/companydeploy/edit/edit')
  },
  // 账单管理 账单明细
  {
    path: '/userinfo/bill/details',
    name: 'billDetails',
    component: () => import('@/page/user/bill/billdetails')
  }
]
const userRouter = [
  {
    // 个人中心
    path: '/userinfo',
    name: 'user',
    redirect: '/userinfo/usermsg',
    meta: {
    },
    component: () => import('@/page/user/userinfo'),
    children: userchildren.concat(company).concat(secondPage).concat(travelSet).concat(bill)
  }
]

export default userRouter



// WEBPACK FOOTER //
// ./src/router/modules/user.js